/* eslint-disable unicorn/consistent-function-scoping */
/* eslint-disable arrow-body-style */
/* eslint-disable react/function-component-definition */
import { Dialog, DialogContent, DialogContentText } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

const Loading = ({ open }: { open: boolean }) => {
  return (
    <Dialog
      open={open}
      PaperProps={{
        style: { backgroundColor: "transparent", boxShadow: "none" },
      }}
    >
      <DialogContent>
        <DialogContentText sx={{ textAlign: "center" }}>
          <CircularProgress
            color="primary"
            style={{
              width: "60px",
              height: "60px",
            }}
          />
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default Loading;
